
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brands-directory",
      function () {
        return require("private-next-pages/brands-directory.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/brands-directory"])
      });
    }
  